"use client";

import React from "react";

import { iconColor } from "./colors";
import { createSVGIcon } from "./createSVGIcon";
import { iconCls } from "./tracking";

/**
 * @figma designed by Gabe Kelley, Nick Howland, Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1597))
 * @lastsynced 2026-10-29T13:53:55.422Z
 * @trackcomponent
 * @optimized using svgo:^3.3.4
 */
export const SaleTag = createSVGIcon(
  <path
    d="m21.122 15.667-5.455 5.455a1.285 1.285 0 0 1-1.819 0L2.69 9.963a.65.65 0 0 1-.187-.497L2.9 3.501a.645.645 0 0 1 .6-.6l5.965-.398a.65.65 0 0 1 .497.187l11.159 11.158a1.285 1.285 0 0 1 0 1.819ZM7.232 8.09a.857.857 0 1 0 1.715 0 .857.857 0 0 0-1.714 0Z"
    strokeLinecap="round"
    strokeLinejoin="round"
    stroke="currentColor"
  />,
  "SaleTag",
  {
    viewBox: "0 0 24 24",
    titleAccess: "SaleTag",
    fill: "none",
    color: iconColor.primary,
    className: iconCls(),
  }
);
